import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { PromotionDialogComponent } from './promotion-dialog.component';



@NgModule({
  declarations: [
    PromotionDialogComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
  ]
})
export class PromotionDialogModule { }
